import React from 'react';
import { Helmet } from 'react-helmet';
import './legal.css';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Vasmi Group</title>
      </Helmet>
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p>Last updated: April 04, 2024</p>
        
        <section>
          <h2>1. Introduction</h2>
          <p>Welcome to Vasmi Group. We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about our policy, or our practices with regards to your personal information, please contact us at info@vasmigroup.com.</p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We collect personal information that you voluntarily provide to us when expressing an interest in obtaining information about us or our products and services, when participating in activities on the Website or otherwise contacting us.</p>
          <p>The personal information that we collect depends on the context of your interactions with us and the Website, the choices you make and the products and features you use. The personal information we collect can include the following:</p>
          <ul>
            <li>Name and Contact Data (Email, Phone Number, Address)</li>
            <li>Information related to your service interests</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use personal information collected via our Website for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations.</p>
        </section>

        <section>
          <h2>4. Sharing Your Information</h2>
          <p>We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.</p>
        </section>

        <section>
          <h2>5. Contact Us</h2>
          <p>If you have questions or comments about this policy, you may email us at info@vasmigroup.com or by post to:</p>
          <p>Vasmi Group<br/>#39-14-8/5, Madhavadara-Murali Nagar Jn, Beside ICICI Bank,<br/>Visakhapatnam - 530007.</p>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
